import { render } from "./PlaceHolderCard.vue?vue&type=template&id=141440e8"
import script from "./PlaceHolderCard.vue?vue&type=script&lang=js"
export * from "./PlaceHolderCard.vue?vue&type=script&lang=js"

import exportComponent from "/Users/ibrahimisa/Documents/Work/HibSoft/Projects/Frontier-Systems/Projects/geep-dashboard/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__